import Error from '../common/errorData'
import CON from '../constant'
import {
  http
} from './index'
const pasurl = CON.URL_DOWN

const getReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.get(urls, {
    params: data
  })
}

const postReq = (url, data) => { // 封装get参数
  const urls = http.adornUrl(url, pasurl)
  return http.post(urls, data)
}
export default {
// 接口提供者:
  listColumnTree: (data) => getReq('/ndata/pc/column/listColumnTree', data).then(Error),
  getSingleByColumn: (data) => getReq('/ndata/pc/contentmain/getSingleByColumn', data).then(Error),
  login: (data) => postReq('/ndata/login', data).then(Error),
  getVideoZone: (data) => getReq('/ndata/pc/column/getVideoZone', data).then(Error),
  getFirstColumn: (data) => getReq('/ndata/pc/column/getFirstColumn', data).then(Error),
  getSecondColumn: (data) => getReq('/ndata/pc/column/getSecondColumn', data).then(Error)
}



// WEBPACK FOOTER //
// ./src/apis/column.js